function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["dictType", "level", "childrenLoadLevel"],
  _excluded2 = ["fillFields", "onChange", "value"],
  _excluded3 = ["url", "method", "autoSearch", "searchOnFocus"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Cascader as AntCascader, Form } from 'antd';
import { useDict } from "./dict";
import { FormContext } from "./Form";
import { useContext } from 'react';
import { useRequestOption } from "./request";
import { useEffectOnce } from 'react-use';
import { isEmpty } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DictCascader = function DictCascader(props) {
  var dictType = props.dictType,
    _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    _props$childrenLoadLe = props.childrenLoadLevel,
    childrenLoadLevel = _props$childrenLoadLe === void 0 ? 5 : _props$childrenLoadLe,
    rest = _objectWithoutProperties(props, _excluded);
  var options = useDict(dictType, {
    level: level,
    childrenLoadLevel: childrenLoadLevel
  });
  return /*#__PURE__*/_jsx(AntCascader, _objectSpread({
    options: options
  }, rest));
};
export var AutoFillDictCascader = function AutoFillDictCascader(props) {
  var _useContext = useContext(FormContext),
    form = _useContext.form;
  var fillFields = props.fillFields,
    onChange = props.onChange,
    value = props.value,
    rest = _objectWithoutProperties(props, _excluded2);
  var handleChange = function handleChange(value, option) {
    console.log(value, option);
    if (form) {
      // const map = dict.getMap(autoDictType)!
      // fillFields?.forEach(([path, key]) => {
      //   const target = _.get(map[value], key) as any
      //   form.setFieldValue(path, target)
      // }, {})
    }
    onChange === null || onChange === void 0 || onChange(value, option);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DictCascader, _objectSpread({
      value: value,
      onChange: handleChange
    }, rest)), fillFields.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        path = _ref2[0];
      return /*#__PURE__*/_jsx(Form.Item, {
        name: path,
        hidden: true,
        preserve: true
      }, path);
    })]
  });
};
export var Cascader = AntCascader;
export var SuggestCascader = function SuggestCascader(props) {
  var url = props.url,
    method = props.method,
    autoSearch = props.autoSearch,
    searchOnFocus = props.searchOnFocus,
    rest = _objectWithoutProperties(props, _excluded3);
  var _useRequestOption = useRequestOption({
      url: url,
      method: method,
      debounce: 300
    }),
    onSearch = _useRequestOption.onSearch,
    options = _useRequestOption.options;
  useEffectOnce(function () {
    if (autoSearch) {
      onSearch('');
    }
  });
  return /*#__PURE__*/_jsx(AntCascader, _objectSpread({
    options: options
  }, rest));
};
export var SuggestCascaderText = function SuggestCascaderText(props) {
  var url = props.url,
    method = props.method,
    value = props.value,
    _props$delimiter = props.delimiter,
    delimiter = _props$delimiter === void 0 ? ', ' : _props$delimiter;
  var _useRequestOption2 = useRequestOption({
      url: url,
      method: method,
      debounce: 300
    }),
    onSearch = _useRequestOption2.onSearch,
    options = _useRequestOption2.options;
  useEffectOnce(function () {
    onSearch('');
  });
  if (isEmpty(value)) {
    return '-';
  }
  if (Array.isArray(value) && options) {
    var currentOptions = options;
    var labels = value.reduce(function (list, current) {
      if (currentOptions) {
        var item = currentOptions.find(function (i) {
          return i.value === current;
        });
        if (item) {
          list.push(item.label);
          list.push(delimiter);
          currentOptions = item.children;
        }
      }
      return list;
    }, []);
    labels.pop();
    var text = labels.join('');
    return /*#__PURE__*/_jsx(_Fragment, {
      children: labels.length ? text : '-'
    });
  }
  if (value != null && !Array.isArray(value) && options) {
    var item = options.find(function (i) {
      return i.value === value;
    });
    if (!item) {
      return '-';
    }
    return item.label || item.value;
  }
  return '-';
};